import { render, staticRenderFns } from "./bottom_pass.vue?vue&type=template&id=27407992&scoped=true&"
import script from "./bottom_pass.vue?vue&type=script&lang=js&"
export * from "./bottom_pass.vue?vue&type=script&lang=js&"
import style0 from "./bottom_pass.vue?vue&type=style&index=0&id=27407992&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27407992",
  null
  
)

export default component.exports